export type AlbumShareTarget = "photos" | "framed" | "videos";

const shareBaseUrl = process.env.NEXT_PUBLIC_SHARE_BASE_URL?.trim() ?? "";

export function getAlbumShortPath(target: AlbumShareTarget) {
  if (target === "photos") return "/s/photos";
  if (target === "framed") return "/s/framed";
  return "/s/videos";
}

export function getPhotoShortPath(id: string) {
  return `/s/p-${encodeURIComponent(id)}`;
}

export function getVideoShortPath(id: string) {
  return `/s/v-${encodeURIComponent(id)}`;
}

export function getDisplayShortLink(shortPath: string) {
  if (shareBaseUrl) {
    return `${shareBaseUrl.replace(/\/$/, "")}${shortPath}`;
  }

  return shortPath;
}

export function getAbsoluteShortLink(shortPath: string) {
  if (shareBaseUrl) {
    return `${shareBaseUrl.replace(/\/$/, "")}${shortPath}`;
  }

  return shortPath;
}

export function canDirectlyShareToSocial() {
  return Boolean(shareBaseUrl);
}
